import { Attribute, Component, OnInit } from '@angular/core';
import { CreateConfiguration } from './moctData';
import {
  IFrameTemplate, FrameTemplate, BuildPakAttribute, ProductTemplate,
  IBp1configurationRequest, Bp1configurationRequest, IBp2ConfigurationRequest,
  Bp2ConfigurationRequest, IV6DefaultOption,
  V6Product, Product,
  IV6Product, Transalation, V6outerFrame, IV6outerFrame, IV6configuration, V6configuration, IProductAttribute,
  IAttributeOption,
  IProductAttributesGetByattributeIdBody,
  IBuildPakAttribute,
  Macro
} from 'src/app/core/models/index';
import { FormBuilder, FormGroup } from '@angular/forms';
import { $ } from 'protractor';
import { debug } from 'console';
import { ProductService } from '../../../../../core/services/product.service';
import { UserService } from '../../../../../core/services/user.service';
import { Router } from '@angular/router';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { bp1_f7 } from './macros';
import { V6productService } from '../../../../../core/services/v6product.service';
import { V6attributeService } from '../../../../../core/services/v6attribute.service';
import { V6macroService } from '../../../../../core/services/v6macro.service';
import { V6translationService } from '../../../../../core/services/v6translation.service';
import { V6ProductCreationStep, V6ProductType } from '../../../../../core/enums';
import { MacroService } from '../../../../../core/services/macro.service';
import { ProductAttributeService } from '../../../../../core/services/product-attribute.service';
import { map, tap } from 'rxjs/operators';
import { CommonService } from '../../../../../core/services/common.service';
import { cloneDeep, forEach } from 'lodash';
import { KKItem } from './KKItemList';

@Component({
  selector: 'app-create-configuration',
  templateUrl: './create-configuration.component.html',
  styleUrls: ['./create-configuration.component.scss']
})
export class CreateConfigurationComponent implements OnInit {

  //#region variables
  selectedproductTemplate: IV6Product = new V6Product();
  transalations: any[];
  attributeList: any[];
  macroList: any[];
  productModel: ProductTemplate;
  ////showEditFrame: true;
  ////frameBuilderForm: FormGroup;
  ////frameName: string;
  ////frameCodePefix: string;
  ////frameAttributes: any[];
  ////frameAttributeName: any;
  ////showManageFrameForm: false;
  ////showFrameBuilder: false;

  ////previewFormIndex: number = 1;//just for now, 1 BP1, 2 BP2
  ////frameEditingSteps: number = -1;//just for test now,0=add resource frame 1=edit resource frame, 2 edit nested frame, 3 add nested frame

  productCreationStep: V6ProductCreationStep;
  selectedAttributeName: string = '';
  selectedNameMacro: string = '';
  selectedBP1Macro: string = '';
  selectedBP2Macro: string = '';
  selectedConfirmMacro: string = '';
  //frameInEditMode: IFrameTemplate = new FrameTemplate();
  //selectedFrameAttribute: BuildPakAttribute;
  //selectedFrameTabIndexBP1 = 0;
  //configCreationInProgres = false;
  selectedProductType: string = '1';
  allV6ProductTypes = [
    { value: '1', name: 'Configured' },
    { value: '2', name: 'KK Door' },
    { value: '3', name: 'KK Frame' },
  ]
  //#endregion


  constructor(
    private userService: UserService,
    private router: Router,
    private appNotifyService: AppNotifyService,
    private formBuilder: FormBuilder,
    private prdService: ProductService,
    private v6prdService: V6productService,
    private v6attrService: V6attributeService,
    private v6mcrService: V6macroService,
    private productAttributeService: ProductAttributeService,
    private v6tranService: V6translationService,
    private commonHelper: CommonService
  ) {
    //determine add or edit mode

    this.configFormIndex = this.v6prdService.configFormIndex;
    this.productModel = this.v6prdService.productModel;
    this.selectedProductType = this.productModel.type.toString();
    this.selectedNameMacro = this.productModel.configNameExpression ? this.productModel.configNameExpression.name : '';
    this.productCreationStep = this.v6prdService.configFormStep;
  }

  ngOnInit() {
    this.v6attrService.getAll()
      .subscribe((resp) => {
        this.attributeList = this.v6attrService.getAttributes();
      });
    this.v6mcrService.getAll()
      .subscribe((resp) => {
        this.macroList = this.v6mcrService.getMacros();
      });
  }

  //#region Events
  attributeFilterChangeHandler(value) {
    this.attributeList = this.v6attrService.attributeFilterChangeHandler(value);
  }

  macroFilterChangeHandler(value: string) {
    this.macroList = this.v6mcrService.macroFilterChangeHandler(value);
  }
  //#endregion
  //#region Navigation
  get configFormIndex(): number {
    return this.v6prdService.configFormIndex;
  }
  set configFormIndex(index: number) {
    this.v6prdService.goToConfigForm(index);
  }
  goTo(index: number) {
    console.log(index);
    this.v6prdService.goToConfigForm(index);
  }

  //#endregion

  //#endregion btn clicks 

  public savePreviewModelToLocalStorage(previewModel: any) {
    localStorage.setItem('kdTempPreviewModel', JSON.stringify(previewModel));
  }
  public readPreviewModelToLocalStorage(): any {
    return JSON.parse(localStorage.getItem('kdTempPreviewModel'));
  }

  saveConfig() {
    this.savePreviewModelToLocalStorage(this.productModel);
  }
  resetConfig() {
    localStorage.removeItem("kdTempPreviewModel");
    this.productModel = new ProductTemplate();
  }
  productTypeChange(e) {
    console.log(e);
    console.log(this.selectedProductType);
    this.productModel = new ProductTemplate();
  }

  async TestUploadKKItems() {
  
    const c = KKItem.getL();
    //190
    //const K190 = c.filter(x => (x["Item Series"] === 190) || (x["Item Series"] === 350) || (x["Item Series"] === 500));//
    const K190 = c.filter(x => true);//
    //debugger;
    for (let i = 0; i < K190.length; i++) {
      //for (let i = 0; i < 1; i++) {
      let e = K190[i];

      if (e["LongItemNumber"] !== '') {

        this.selectedproductTemplate.name = e["LongItemNumber"];
        this.selectedproductTemplate.id = -1;
        this.selectedproductTemplate.typeId = e["TypeId"].toString();
        this.selectedproductTemplate.productCode = e["LongItemNumber"];
        //raw if else
        let prd = new ProductTemplate();
        prd.productCode = e["LongItemNumber"];
        prd.productName = e["LongItemNumber"];

        switch (this.selectedproductTemplate.typeId) {
          case "2":
            prd.type = V6ProductType.KWIK_KEY_DOOR;
            this.initKwikeyProductTemplate(prd);
            break;
          case "3":
            prd.type = V6ProductType.KWIK_KEY_FRAME;
            this.initKwikeyProductTemplate(prd);
            break;
          default: this.productModel.type = V6ProductType.CONFIGURED; break;
        }

        this.selectedproductTemplate.dependentAttributeIdList = this.v6prdService.getAllProductAttributesIds(prd).join(',');
        this.selectedproductTemplate.dependentMacroIdList = this.v6prdService.getAllMacroIds(prd).join(',');
        console.log(this.productModel);
        this.selectedproductTemplate.templateDescription = JSON.stringify(prd);
        console.log(this.selectedproductTemplate);
        //return;
        //PREPARE REST PROPERTIES FOR selectedproductTemplate
        //if (this.selectedproductTemplate.id > 0) {
        //  //go for update
        //  this.prdService.updateProductTemplate(this.selectedproductTemplate).subscribe(r => {
        //    console.log(r);
        //    this.appNotifyService.notify(NotifyType.SUCCESS, "Product Template has been updated successfully");
        //    //this.router.navigate(['/manageProduct']);
        //  });
        //} else {
        let c = await this.prdService.createProductTemplate(this.selectedproductTemplate).toPromise();
        console.log(c);
        //.subscribe(r => {
        //  console.log(r);
        //  this.appNotifyService.notify(NotifyType.SUCCESS, "Product Template has been added successfully");
        //  //this.router.navigate(['/manageProduct']);
        //})
        //}

      }
    }
  }
  initKwikeyProductTemplate(prd: ProductTemplate) {
    //debugger;
    prd.productAttributes = [];
    prd.resourceFrame = new FrameTemplate();
    //compute name
    const parts = prd.productCode.split('-');
    if (parts.length < 2) {
      console.log('problem', prd.productCode); return;
    }
    prd.kwikKeyProductSeries = parts[0];
    prd.kwikKeyOptionCode = parts[1];
    const finish = parts[2];
    const reg = /17/g;
    const finValue = '[COL:K:17 (17)]'.replace(reg, finish);
    prd.kwikKeyFinish = finish;
    prd.kwikKeyV6Finish = finValue;


    switch (prd.type) {
      case V6ProductType.KWIK_KEY_DOOR:
        let attr0 = this.v6attrService.getAttributeByName('Exterior Finish-Modified by Bill');
        let attr01 = this.v6attrService.getAttributeByName('All Push/Pull Finishs');
        let attr1 = this.v6attrService.getAttributeByName('Hardware Finish modified by bill');
        let attr2 = this.v6attrService.getAttributeByName('Cross Rails');
        let attr3 = this.v6attrService.getAttributeByName('Kwikkey_FrameSeries');
        let attr4 = this.v6attrService.getAttributeByName('Transom');
        attr0.show = false;
        attr0.value = finValue;
        attr01.show = false;
        attr01.value = finValue;
        prd.productAttributes.push(attr0);
        prd.productAttributes.push(attr01);
        prd.productAttributes.push(attr1);
        if (prd.productCode.indexOf('PNL') < 0) {
          prd.productAttributes.push(attr2);
        }
        prd.resourceFrame.frameName = 'Add Frame'
        prd.resourceFrame.frameAdditionalText = 'Leave default if not adding door/frame'
        prd.resourceFrame.attributeFilters.push(attr3)
        prd.resourceFrame.attributeFilters.push(attr4)
        if (prd.kwikKeyProductSeries === '190' || prd.kwikKeyProductSeries === '350' || prd.kwikKeyProductSeries === '500') {
          prd.bp2Macros = [];
          prd.bp2Macros.push(({ id: 1, name: "show hide concealed closer prep", type: null, expression: null }) as Macro);
          prd.bp2Macros.push(({ id: 2, name: "validate concealed closer prep", type: null, expression: null }) as Macro);
          prd.bp2Macros.push(({ id: 3, name: "show hide powersupply", type: null, expression: null }) as Macro);
          prd.bp2Macros.push(({ id: 10, name: "HIDE PUSHPULL FINISH ON SCR2", type: null, expression: null }) as Macro);
        }
        break;
      case V6ProductType.KWIK_KEY_FRAME:
        let attr0f = this.v6attrService.getAttributeByName('Exterior Finish-Modified by Bill');
        let attr01f = this.v6attrService.getAttributeByName('All Push/Pull Finishs');
        let attr1f = this.v6attrService.getAttributeByName('Hardware Finish modified by bill');
        let attr2f = this.v6attrService.getAttributeByName('Transom');
        let attr3f = this.v6attrService.getAttributeByName('Kwikkey_DoorType');
        let attr4f = this.v6attrService.getAttributeByName('Cross Rails');
        attr0f.show = false;
        attr0f.value = finValue;
        attr01f.show = false;
        attr01f.value = finValue;
        prd.productAttributes.push(attr0f);
        prd.productAttributes.push(attr01f);
        prd.productAttributes.push(attr1f);
        prd.productAttributes.push(attr2f);
        prd.resourceFrame.frameName = 'Add Door'
        prd.resourceFrame.frameAdditionalText = 'Leave default if not adding door/frame'
        prd.resourceFrame.attributeFilters.push(attr3f)

        if (prd.productCode.indexOf('PNL') < 0) {
          prd.resourceFrame.attributeFilters.push(attr4f)
        }

        if (prd.kwikKeyProductSeries === '400' || prd.kwikKeyProductSeries === '450' || prd.kwikKeyProductSeries === '451') {
          prd.bp2Macros = [];
          prd.bp2Macros.push(({ id: 1, name: "show hide concealed closer prep", type: null, expression: null }) as Macro);
          prd.bp2Macros.push(({ id: 2, name: "validate concealed closer prep", type: null, expression: null }) as Macro);
        }
        break;
      default: break;
    }
  }
  saveK(p, t) {
    this.selectedproductTemplate.name = p;
    this.selectedproductTemplate.id = -1;
    this.selectedproductTemplate.typeId = t;
    this.selectedproductTemplate.productCode = p;
    //raw if else
    switch (this.selectedProductType) {
      case V6ProductType.CONFIGURED.toString():
        this.productModel.type = V6ProductType.CONFIGURED;
        break;
      case V6ProductType.KWIK_KEY_DOOR.toString():
        this.productModel.type = V6ProductType.KWIK_KEY_DOOR;
        this.initKwikeyProductTemplate(this.productModel);
        break;
      case V6ProductType.KWIK_KEY_FRAME.toString():
        this.productModel.type = V6ProductType.KWIK_KEY_FRAME;
        this.initKwikeyProductTemplate(this.productModel);
        break;
      default: this.productModel.type = V6ProductType.CONFIGURED; break;
    }
    this.selectedproductTemplate.dependentAttributeIdList = this.v6prdService.getAllProductAttributesIds(this.productModel).join(',');
    this.selectedproductTemplate.dependentMacroIdList = this.v6prdService.getAllMacroIds(this.productModel).join(',');
    console.log(this.productModel);
    this.selectedproductTemplate.templateDescription = JSON.stringify(this.productModel);
    //PREPARE REST PROPERTIES FOR selectedproductTemplate
    if (this.selectedproductTemplate.id > 0) {
      //go for update
      this.prdService.updateProductTemplate(this.selectedproductTemplate).subscribe(r => {
        console.log(r);
        //this.appNotifyService.notify(NotifyType.SUCCESS, "Product Template has been updated successfully");
        //this.router.navigate(['/manageProduct']);
      });
    } else {
      this.prdService.createProductTemplate(this.selectedproductTemplate).subscribe(r => {
        console.log(r);
        //this.appNotifyService.notify(NotifyType.SUCCESS, "Product Template has been added successfully");
        //this.router.navigate(['/manageProduct']);
      });
    }
  }

  saveToDatabaseConfig() {
    this.selectedproductTemplate.name = this.productModel.productName;
    this.selectedproductTemplate.id = this.v6prdService.testPrdTempId;
    this.selectedproductTemplate.typeId = this.selectedProductType;
    this.selectedproductTemplate.productCode = this.productModel.productCode;
    //raw if else
    switch (this.selectedProductType) {
      case V6ProductType.CONFIGURED.toString():
        this.productModel.type = V6ProductType.CONFIGURED;
        break;
      case V6ProductType.KWIK_KEY_DOOR.toString():
        this.productModel.type = V6ProductType.KWIK_KEY_DOOR;
        this.initKwikeyProductTemplate(this.productModel);
        break;
      case V6ProductType.KWIK_KEY_FRAME.toString():
        this.productModel.type = V6ProductType.KWIK_KEY_FRAME;
        this.initKwikeyProductTemplate(this.productModel);
        break;
      default: this.productModel.type = V6ProductType.CONFIGURED; break;
    }
    if (this.selectedNameMacro && this.selectedNameMacro.length > 0) {
      const mcr = this.macroList.find(x => x.name === this.selectedNameMacro);
      if (mcr) {
        this.productModel.configNameExpression = mcr;
      }
    }

    this.selectedproductTemplate.dependentAttributeIdList = this.v6prdService.getAllProductAttributesIds(this.productModel).join(',');
    this.selectedproductTemplate.dependentMacroIdList = this.v6prdService.getAllMacroIds(this.productModel).join(',');
    console.log(this.productModel);
    this.selectedproductTemplate.templateDescription = JSON.stringify(this.productModel);
    //PREPARE REST PROPERTIES FOR selectedproductTemplate
    if (this.selectedproductTemplate.id > 0) {
      //go for update
      this.prdService.updateProductTemplate(this.selectedproductTemplate).subscribe(r => {
        console.log(r);
        this.appNotifyService.notify(NotifyType.SUCCESS, "Product Template has been updated successfully");
        //this.router.navigate(['/manageProduct']);
      });
    } else {
      this.prdService.createProductTemplate(this.selectedproductTemplate).subscribe(r => {
        console.log(r);
        this.appNotifyService.notify(NotifyType.SUCCESS, "Product Template has been added successfully");
        //this.router.navigate(['/manageProduct']);
      });
    }
  }
  //initKwikKeyAdditionalDetails(productTemplate) {
  //  const parts = productTemplate.productCode.split('-');
  //  if (parts.lenght > 2) {
  //    const productSeries = parts[0];
  //    const frameCode = parts[1];
  //    const finish = parts[2];
  //    const finValue = '[COL:K:17 (17)]'.replace('17', finish);
  //  }
  //}


  //#endregion


  //#region Product Template Design
  //#region General Config Area
  //#region Product Attributes
  addProductAttribute() {
    if (this.selectedAttributeName) {
      const attribute = this.attributeList.find(x => x.name === this.selectedAttributeName);
      //check if already present in the attribute list
      const doesExist = this.productModel.productAttributes.find(x => x.name === attribute.name) ? true : false;
      if (!doesExist) {
        this.productModel.productAttributes.push(attribute);
      }
      console.log(attribute);
    }

    this.selectedAttributeName = '';
  }
  removeProductAttribute(productAttributeIndex) {
    if (this.productModel.productAttributes.length > productAttributeIndex) {
      (this.productModel.productAttributes as []).splice(productAttributeIndex, 1);
    }
  }
  //#endregion
  //#region BP1 Macros
  addBP1Macro(): void {
    if (this.selectedBP1Macro) {
      const bp1Macro = this.macroList.find(x => x.name === this.selectedBP1Macro);
      const doesExist = this.productModel.bp1Macros.find(x => x.name === this.selectedBP1Macro) ? true : false;
      if (!doesExist) {
        this.productModel.bp1Macros.push(bp1Macro);
      }
    }
    this.selectedBP1Macro = '';
  }
  removeBP1Macro(bp1MacroIndex: number): void {
    if (this.productModel.bp1Macros.length > bp1MacroIndex) {
      (this.productModel.bp1Macros as []).splice(bp1MacroIndex, 1);
    }
  }
  //#endregion
  //#region BP2 Macros
  addBP2Macro(): void {
    if (this.selectedBP2Macro) {
      const bp2Macro = this.macroList.find(x => x.name === this.selectedBP2Macro);
      const doesExist = this.productModel.bp2Macros.find(x => x.name === this.selectedBP2Macro) ? true : false;
      if (!doesExist && bp2Macro) {
        this.productModel.bp2Macros.push(bp2Macro);
      }
    }
    this.selectedBP2Macro = '';
  }
  removeBP2Macro(bp2MacroIndex): void {
    if (this.productModel.bp2Macros.length > bp2MacroIndex) {
      (this.productModel.bp2Macros as []).splice(bp2MacroIndex, 1);
    }
  }
  //#endregion
  //#region BP2 Macros
  addConfirmMacro(): void {
    if (this.selectedConfirmMacro) {
      const confirmMacro = this.macroList.find(x => x.name === this.selectedConfirmMacro);
      if (!this.productModel.confirmMacros) {
        this.productModel.confirmMacros = [];
      }
      const doesExist = this.productModel.confirmMacros.find(x => x.name === this.selectedConfirmMacro) ? true : false;
      if (!doesExist && confirmMacro) {
        this.productModel.confirmMacros.push(confirmMacro);
      }
    }
    this.selectedConfirmMacro = '';
  }
  removeConfirmMacro(confirmMacroIndex): void {
    if (this.productModel.confirmMacros.length > confirmMacroIndex) {
      (this.productModel.confirmMacros as []).splice(confirmMacroIndex, 1);
    }
  }
  //#endregion
  //#endregion
  //#endregion
  //#region Navigation
  goToManageFrames() {
    this.configFormIndex = 2;
    this.productCreationStep = V6ProductCreationStep.MANAGE_FRAME;
  }
  //#endregion
  //#region Preview Model
  updatePreview() {
    const prdPrev = new V6Product();
    prdPrev.name = this.productModel.productName;
    prdPrev.id = this.v6prdService.testPrdTempId;
    prdPrev.typeId = this.selectedProductType;
    prdPrev.productCode = this.productModel.productCode;
    prdPrev.dependentAttributeIdList = this.v6prdService.getAllProductAttributesIds(this.productModel).join(',');
    prdPrev.dependentMacroIdList = this.v6prdService.getAllMacroIds(this.productModel).join(',');
    prdPrev.template = cloneDeep(this.productModel);
    this.v6prdService.v6ProductPreview = prdPrev;
    this.v6prdService.shouldUpdatePreview.next(true);
  }
  //#endregion


}
